import { useState } from "react";
import "./style.css";
import { BsFillArrowUpRightSquareFill } from "react-icons/bs";

// Website Images
import W1 from "../../assets/PortfolioWebPics/6-1.jpg";
import W2 from "../../assets/PortfolioWebPics/7-1.jpg";
import W3 from "../../assets/PortfolioWebPics/8-1.jpg";
import W4 from "../../assets/PortfolioWebPics/1-1.jpg";
import W5 from "../../assets/PortfolioWebPics/2-1.jpg";
import W6 from "../../assets/PortfolioWebPics/3-1.jpg";
import W7 from "../../assets/PortfolioWebPics/4-1.jpg";
import W8 from "../../assets/PortfolioWebPics/5-1.jpg";
import W9 from "../../assets/PortfolioWebPics/9-1.jpg";
import W10 from "../../assets/PortfolioWebPics/10-1.jpg";
import W11 from "../../assets/PortfolioWebPics/11-1.jpg";
import W12 from "../../assets/PortfolioWebPics/12-1.jpg";
import W13 from "../../assets/PortfolioWebPics/13-1.jpg";

// 3D Images
import Model1 from "../../assets/3D/1.png";
import Model2 from "../../assets/3D/2.jpg";
import Model3 from "../../assets/3D/3.jpg";
import Model4 from "../../assets/3D/4.png";
import Model5 from "../../assets/3D/5.jpg";
import Model6 from "../../assets/3D/6.jpg";
import Model7 from "../../assets/3D/7.jpg";
import Model8 from "../../assets/3D/8.jpg";
import Model9 from "../../assets/3D/9.jpg";
import Model10 from "../../assets/3D/10.jpg";
import Model11 from "../../assets/3D/11.jpg";
import Model12 from "../../assets/3D/12.jpg";
import Model13 from "../../assets/3D/13.jpg";
import Model14 from "../../assets/3D/14.jpg";
import Model15 from "../../assets/3D/15.jpg";

const websiteProjects = [
  {
    title: "FirstDrive Company Website",
    description:
      "Designed and developed a modern company website for FirstDrive, an official Yandex partner in Armenia, focusing on performance, responsive design, and a seamless user experience.",
    image: W12,
    link: "https://www.firstdrive.am",
  },
  {
    title: "MyService Company Website",
    description:
      "Built a modern multilingual website for MyService, a local service platform in Armenia, with a clean interface designed to improve customer engagement and service discovery.",
    image: W9,
    link: "https://www.myservice.am/",
  },
  {
    title: "MyService Partner Dashboard",
    description:
      "Developed a partner management dashboard allowing MyService providers to manage services and customers through an intuitive interface.",
    image: W10,
    link: "https://partner.myservice.am/am",
  },
  {
    title: "The Starlife Group Company Website",
    description:
      "Created a premium corporate website for The Starlife Group, a Miami-based construction and investment company.",
    image: W11,
    link: "https://thestarlifegroup.com",
  },
  {
    title: "Easy4All Website",
    description:
      "Developed an accessibility-focused website for Easy4All, an inclusive widget that helps users with disabilities customize websites for a more comfortable browsing experience.",
    image: W13,
    link: "",
  },
  {
    title: "Team2B Company Website",
    description:
      "Created a multilingual business website for Team2B, showcasing their accounting, legal, branding, and marketing services through a modern and engaging digital experience.",
    image: W2,
    link: "https://team2b.am/",
  },
  {
    title: "Movie Website with Recommendation System",
    description:
      "Developed a dynamic movie platform inspired by IMDb, featuring movies and a recommendation system as a final capstone project.",
    image: W1,
    link: "https://github.com/Arshak22/Capstone-Project",
  },
  {
    title: "Xbox Gamepad Store",
    description:
      "Built an e-commerce platform dedicated to Xbox controllers and gaming accessories, featuring product browsing, modern UI design, and a smooth shopping experience.",
    image: W3,
    link: "https://xperiencexpad.netlify.app/",
  },
  {
    title: "Real Estate Agent Website",
    description:
      "Designed a modern real estate website template that helps agents showcase properties, connect with clients, and create a professional online presence.",
    image: W4,
    link: "",
  },
  {
    title: "Insurance Agent Website",
    description:
      "Developed a professional insurance agency website template focused on customer trust, service presentation, and effective lead generation.",
    image: W5,
    link: "https://demo8.mbswebsite.com/",
  },
  {
    title: "Insurance Agent Website",
    description:
      "Created a customizable insurance website template designed to highlight agency services, improve online visibility, and support client communication.",
    image: W6,
    link: "",
  },
  {
    title: "Insurance Agent Website",
    description:
      "Designed a sleek insurance agency website concept with a focus on personalized branding, user-friendly navigation, and customer engagement.",
    image: W7,
    link: "",
  },
];

const modelProjects = [
  {
    title: "MyService Logo",
    image: Model12,
    link: "https://my.spline.design/myservicelogo-hNnVcHU7DMwmchKwld9wwwkO/",
  },
  {
    title: "SHEMM Logo",
    image: Model13,
    link: "https://my.spline.design/shemmteam2b-dd306ac41ba38fbf59c431ba19dd2ec9/",
  },
  {
    title: "GC Logo",
    image: Model14,
    link: "https://my.spline.design/gc-3007eaa7ce388b287dc6127ea4c4ea04/",
  },
  {
    title: "Dental Smart Logo",
    image: Model15,
    link: "https://my.spline.design/dentalsmart-91ab6511c2fc5d592e020a0070eb35e4/",
  },
  {
    title: "StarLife Group Street Banner",
    image: Model4,
    link: "https://my.spline.design/untitled-cc9e9edeb1ba80974c5ab29966516511/",
  },
  {
    title: "Skrillix Energy Drinks",
    image: Model1,
    link: "https://my.spline.design/alldrinks-849c590ead1ca9712f8651cc9e15f3d1/",
  },
  {
    title: "Robot for Landing Page",
    image: Model2,
    link: "https://my.spline.design/untitled-346683fcb1005821c8b72c72f1be84ba/",
  },
  {
    title: "Custom Chess Set",
    image: Model3,
    link: "https://my.spline.design/chessboard-163095a568526d10c174aac1239eae30/",
  },

  {
    title: "Ucom Coffee Cup",
    image: Model5,
    link: "https://my.spline.design/ucomcup-7e2213a692557d310f46eb4a7c336ac5/",
  },
  {
    title: "Fanta Can Aesthetic",
    image: Model6,
    link: "https://my.spline.design/untitled-df7cdc6b543d0f97a30a4e2ed5675c70/",
  },
  {
    title: "Clash Royale Spirits",
    image: Model7,
    link: "https://my.spline.design/untitled-5884b7280d4700581d969b2782dd0414/",
  },
  {
    title: "Halloween",
    image: Model8,
    link: "https://my.spline.design/untitled-a93434b16db9470c088a7cb4cdcf79ba/",
  },
  {
    title: "Guitar on Stage",
    image: Model9,
    link: "https://my.spline.design/guitaraesthetic-0f55ec076448e279594f00bd5e16f71c/",
  },
  {
    title: "Hot Mexican Sauce",
    image: Model10,
    link: "https://my.spline.design/ketchup-94ee780d4b9bec806f85d74ac6d48f33/",
  },
  {
    title: "Poker Cards",
    image: Model11,
    link: "https://my.spline.design/poker-0fd10ddf03edad991bf856feb67e9e17/",
  },
];

const ProjectGrid = ({ projects, isWebsite }) => (
  <div className="portfolio-grid show">
    {projects.map((project, index) => (
      <figure className="website-figure" key={index}>
        <img src={project.image} alt={project.title} loading="lazy" />

        <div className="cube-overlay">
          {Array.from({ length: 25 }).map((_, i) => (
            <span
              key={i}
              style={{
                "--delay": `${i * 0.015}s`,
              }}
            />
          ))}
        </div>

        <figcaption>
          <h3>{project.title}</h3>

          {isWebsite && project.description && <p>{project.description}</p>}

          {project.link && (
            <div className="icons">
              <a href={project.link} target="_blank" rel="noopener noreferrer">
                <BsFillArrowUpRightSquareFill />
              </a>
            </div>
          )}
        </figcaption>
      </figure>
    ))}
  </div>
);

export default function Portfolio() {
  const [isWebsites, setIsWebsites] = useState(true);

  return (
    <div className="portfolio">
      <h2>My Recent Work</h2>

      <div className="switch-wrapper">
        <div className="switch-content-wrapper">
          <div
            className="switch-label-wrapper"
            onClick={() => setIsWebsites(true)}
          >
            <p className={`switch-label ${isWebsites ? "active" : ""}`}>
              Websites
            </p>
          </div>

          <div
            className="switch-label-wrapper"
            onClick={() => setIsWebsites(false)}
          >
            <p className={`switch-label ${!isWebsites ? "active" : ""}`}>
              3D Models
            </p>
          </div>

          <div className={`switch-pill ${!isWebsites ? "clicked" : ""}`} />
        </div>
      </div>

      {isWebsites ? (
        <ProjectGrid projects={websiteProjects} isWebsite />
      ) : (
        <ProjectGrid projects={modelProjects} />
      )}
    </div>
  );
}
